import React from 'react';
import {
  withStyles,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  TextField,
  FormHelperText,
} from '@material-ui/core';
import { withTranslation } from 'react-i18next';

class BedForm extends React.PureComponent {
  render() {
    const { classes, t } = this.props;

    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.handleCloseForm}
        aria-labelledby='form-dialog-title'
        maxWidth='sm'
        fullWidth
        PaperProps={{
          style: {
            borderRadius: 8,
          },
        }}
      >
        <DialogTitle className='header' id='form-dialog-title'>
          <Grid container style={{ position: 'relative' }}>
            <div className={classes.textHeader}>{t('wizard_bed_create')}</div>
            <div id='closeIcon' className='closeIcon' onClick={this.props.handleCloseForm}>
              <svg width='32' height='32' viewBox='0 0 32 32'>
                <use xlinkHref={`/images/menus-v1.svg#close`} />
              </svg>
            </div>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <Grid container item md={12} xs={12} alignItems='center'>
            <Grid item md={12} xs={12}>
              <Typography
                style={{
                  fontWeight: 500,
                  fontSize: 18,
                }}
              >
                {t('wizard_module_no_of_beds')}*
              </Typography>
            </Grid>
            <Grid item md={12} xs={12}>
              <TextField
                required
                id='numberOfBeds'
                name='numberOfBeds'
                fullWidth
                value={this.props.data.numberOfBeds}
                onChange={(e) => this.props.handleChange(e)}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^0-9]/g, '');
                }}
                inputProps={{ maxLength: 3 }}
                variant='outlined'
                margin='dense'
                className={classes.textField}
                InputProps={{
                  className: classes.input,
                }}
              />
              <FormHelperText error hidden={!this.props.errorField.numberOfBeds.flag} id='component-error-text'>
                {this.props.errorField.numberOfBeds.msg}
              </FormHelperText>
            </Grid>
          </Grid>

          <Grid container item md={12} xs={12} alignItems='center'>
            <Grid item md={12} xs={12}>
              <Typography
                style={{
                  fontWeight: 500,
                  fontSize: 18,
                }}
              >
                {t('wizard_bed_prefix')}
              </Typography>
            </Grid>
            <Grid item md={12} xs={12}>
              <TextField
                id='name'
                name='bedName'
                fullWidth
                value={this.props.data.bedName}
                onChange={(e) => this.props.handleChange(e)}
                variant='outlined'
                margin='dense'
                className={classes.textField}
                InputProps={{
                  className: classes.input,
                }}
              />
            </Grid>
          </Grid>

          <Grid container item md={12} xs={12} alignItems='center'>
            <Grid item md={12} xs={12}>
              <Typography
                style={{
                  fontWeight: 500,
                  fontSize: 18,
                }}
              >
                {t('bed_type')}
              </Typography>
            </Grid>
            <Grid item md={12} xs={12}>
              <TextField
                select
                id='typeId'
                name='bedTypeId'
                fullWidth
                value={this.props.data.bedTypeId || 0}
                onChange={(e) => this.props.handleChange(e)}
                variant='outlined'
                margin='dense'
                className={classes.textField}
                InputProps={{
                  className: classes.input,
                }}
                SelectProps={{
                  native: true,
                }}
              >
                <option value={0}>{t('wizard_select_bed_type')}</option>
                {(this.props.bedType || []).map((val) => (
                  <option fullwidth='true' key={val.id} value={val.id}>
                    {val.name}
                  </option>
                ))}
              </TextField>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Grid container style={{ margin: 20, justifyContent: 'right' }}>
            <Button
              id='add'
              variant='contained'
              color='primary'
              className={classes.btnPrimary}
              onClick={this.props.handleSubmitForm}
            >
              {t('add')}
            </Button>
          </Grid>
        </DialogActions>
      </Dialog>
    );
  }
}

const styles = (theme) => ({
  textHeader: {
    display: 'flex',
    justifyContent: 'center',
    color: theme.palette.text.header,
    fontWeight: 500,
    fontSize: 30,
  },
  wrapButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'right',
  },
  btnPrimary: {
    width: 200,
    borderRadius: '4px',
  },
  textField: {
    fontWeight: 400,
  },
  input: {
    color: theme.palette.text.primary,
    height: 40,
  },
});

export const translation = withTranslation()(BedForm);
export default withStyles(styles, { withTheme: true })(translation);
